import i18n from '@/plugins/i18n';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const betOrderPregameTimeoutDictionary = createSimpleDictionary(
    [
        { id: 5, name: '5 sec' },
        { id: 10, name: '10 sec' },
        { id: 15, name: '15 sec' },
        { id: 30, name: '30 sec' },
        { id: 60, name: '1 min' },
        { id: 120, name: '2 mins' },
        { id: 300, name: '5 mins' },
        { id: 600, name: '10 mins' },
        { id: 900, name: '15 mins' },
        { id: 1200, name: '20 mins' },
        { id: 1800, name: '30 mins' },
        { id: 2700, name: '45 mins' },
        { id: 3600, name: '1 hr' },
        { id: 7200, name: '2 hrs' },
        { id: 14400, name: '4 hrs' },
        { id: 21600, name: '6 hrs' },
        { id: 43200, name: '12 hrs' },
        { id: 86400, name: '24 hrs' },
        { id: 172800, name: '48 hrs' },
        { id: 259200, name: '72 hrs' },
        { id: 0, name: i18n.global.t('common.kickOff') }, // it will be not translated after change locale
    ],
    []
);
